import React, { useState } from "react";
import { Navigation } from "./navigation";
import { MenuToggle } from "./menu-toggle";
import { motion } from 'framer-motion';

export default function Menu() {
    const [isOpen, setIsOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const toggleMenu = () => {
        setIsAnimating(true); // Start animation
        setTimeout(() => {
            setIsOpen(!isOpen);
        }, 1);
    };

    const floatingMenu = {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        width: isOpen || isAnimating ? 'calc(var(--vh) * 230px)' : 0,
        zIndex: 1000
    }

    const menuBackground = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: 'calc(var(--vh) * 260px)',
        background: 'var(--orange)',
        boxShadow: '0px 3.201px 10px 0px rgba(0, 0, 0, 0.15)'
    }

    return (
        <>
            {/* <MenuToggle toggle={toggleMenu} /> */}

            {/* Backdrop */}
            {(isOpen || isAnimating) && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        zIndex: 999,
                    }}
                    onClick={toggleMenu} // Close the menu when clicking outside
                />
            )}

            <motion.nav
                initial={false}
                animate={isOpen ? "open" : "closed"}
                custom={window.innerHeight}
                style={floatingMenu}
                onAnimationComplete={() => {
                    if (!isOpen) setIsAnimating(false); // Stop rendering when animation completes
                }}
            >
                {(isOpen || isAnimating) && (
                    <>
                        <motion.div
                            style={menuBackground}
                            variants={sidebar}
                        />
                        <Navigation closeOnNavigate={toggleMenu} />
                    </>
                )}

                <MenuToggle toggle={toggleMenu} />
            </motion.nav>
        </>
    );
}

const sidebar = {
    open: (height = 1000) => ({
        clipPath: `circle(100vh at 40px 40px)`,
        transition: {
            type: "spring",
            stiffness: 20,
            restDelta: 2,
        },
    }),
    closed: {
        clipPath: "circle(0vh at 40px 40px)",
        transition: {
            delay: 0.5,
            type: "spring",
            stiffness: 400,
            damping: 40,
        },
    },
};
